import { render, staticRenderFns } from "./PlayerProcessedMenuPhone.vue?vue&type=template&id=688b0343&scoped=true&"
import script from "./PlayerProcessedMenuPhone.vue?vue&type=script&lang=js&"
export * from "./PlayerProcessedMenuPhone.vue?vue&type=script&lang=js&"
import style0 from "./PlayerProcessedMenuPhone.vue?vue&type=style&index=0&id=688b0343&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "688b0343",
  null
  
)

export default component.exports